import { Card } from '@apovisio/ui';
import { Link } from 'react-router';
import { BrandMark } from '../app/BrandMark';

export function NotFoundPage() {
  return (
    <main className="app-centered">
      <Card padding="lg" className="app-narrow" as="div">
        <BrandMark />
        <h1 className="app-title">Page introuvable</h1>
        <p className="av-text-secondary">L’adresse demandée n’existe pas.</p>
        <Link to="/">Retour à l’accueil</Link>
      </Card>
    </main>
  );
}
